module.exports = __webpack_public_path__ + "a72c49ce3199863a2c5dd64d17d98eff.svg";